<div class="mdc-snackbar" :class="classes_">
	<div class="mdc-snackbar__surface">
		<!-- Message that will be show in snackbar body -->
		<div class="mdc-snackbar__label" role="status" aria-live="polite">
			{{ message }}
		</div>
		<div class="mdc-snackbar__actions" v-show="action">
			<!-- Action Button  -->
			<mom-button type="button" class="mdc-snackbar__action" ref="actionBtn">{{ action }}</mom-button>
	  	</div>
	</div>
</div>
